import { createFileRoute } from '@tanstack/react-router';
import { CommandCenter } from '../../components/command-center/CommandCenter';

export const Route = createFileRoute('/_auth/')({
  component: CommandCenter,
});
